var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"timeout":5000,"bottom":"","right":"","color":"success","elevation":"24"},model:{value:(_vm.showNotification),callback:function ($$v) {_vm.showNotification=$$v},expression:"showNotification"}},[_c('v-icon',[_vm._v(" mdi-checkbox-marked-circle ")]),_c('span',[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }